import React, { useState, useEffect } from "react";
import { Modal, Button, Form, ListGroup, InputGroup } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
    fetchAllTechniqueCategories,
    addTechniqueCategoryAction,
    editTechniqueCategoryAction,
} from "../../utils/redux/techniqueCategory/techniqueCategoryActions";

const TechniqueCategoryModal = ({ show, handleClose }) => {
    const dispatch = useDispatch();
    const { techniqueCategories } = useSelector((state) => state.techniqueCategory);

    // For adding new category
    const [newCategory, setNewCategory] = useState("");
    const [addError, setAddError] = useState("");

    // For editing
    const [editId, setEditId] = useState(null);
    const [editValue, setEditValue] = useState("");
    const [editError, setEditError] = useState("");

    useEffect(() => {
        if (show) dispatch(fetchAllTechniqueCategories());
    }, [show, dispatch]);

    const handleAddCategory = async (e) => {
        e.preventDefault();
        setAddError("");
        if (!newCategory.trim()) {
            setAddError("Category name is required");
            return;
        }
        const res = await dispatch(addTechniqueCategoryAction({ name: newCategory.trim() }));
        if (res?.success) setNewCategory("");
        else setAddError(res?.message || "Failed to add category");
    };

    const handleEditClick = (cat) => {
        setEditId(cat._id);
        setEditValue(cat.name);
        setEditError("");
    };

    const handleEditSave = async (cat) => {
        setEditError("");
        if (!editValue.trim()) {
            setEditError("Category name is required");
            return;
        }
        const res = await dispatch(editTechniqueCategoryAction(cat._id, { name: editValue.trim() }));
        if (res?.success) setEditId(null);
        else setEditError(res?.message || "Failed to edit category");
    };

    const handleEditCancel = () => {
        setEditId(null);
        setEditValue("");
        setEditError("");
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Manage Technique Categories</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleAddCategory} className="mb-3">
                    <InputGroup>
                        <Form.Control
                            placeholder="Add new technique category"
                            value={newCategory}
                            onChange={(e) => setNewCategory(e.target.value)}
                            isInvalid={!!addError}
                        />
                        <Button type="submit" variant="primary">
                            Add
                        </Button>
                        <Form.Control.Feedback type="invalid">{addError}</Form.Control.Feedback>
                    </InputGroup>
                </Form>
                <ListGroup>
                    {techniqueCategories?.length === 0 && (
                        <ListGroup.Item>No technique categories found.</ListGroup.Item>
                    )}
                    {techniqueCategories?.map((cat) => (
                        <ListGroup.Item key={cat._id} className="d-flex align-items-center">
                            {editId === cat._id ? (
                                <>
                                    <Form.Control
                                        value={editValue}
                                        onChange={(e) => setEditValue(e.target.value)}
                                        isInvalid={!!editError}
                                        size="sm"
                                        className="me-2"
                                    />
                                    <Button
                                        variant="success"
                                        size="sm"
                                        className="me-1"
                                        onClick={() => handleEditSave(cat)}
                                    >
                                        Save
                                    </Button>
                                    <Button
                                        variant="secondary"
                                        size="sm"
                                        onClick={handleEditCancel}
                                    >
                                        Cancel
                                    </Button>
                                    <Form.Control.Feedback type="invalid">
                                        {editError}
                                    </Form.Control.Feedback>
                                </>
                            ) : (
                                <>
                                    <span className="flex-grow-1">{cat.name}</span>
                                    <Button
                                        variant="outline-primary"
                                        size="sm"
                                        onClick={() => handleEditClick(cat)}
                                    >
                                        Edit
                                    </Button>
                                </>
                            )}
                        </ListGroup.Item>
                    ))}
                </ListGroup>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default TechniqueCategoryModal;